import { Purchase } from '@bzbs/react-api-client';
import { campaignType } from '../constant';

export type PurchaseItemInfo = {
  title: string;
  pointPerUnit: number;
  expireDate: Date;
  expiredIn?: number;
  image: string;
  showCode: boolean;
  expired: boolean;
  status: PurchaseItemStatus;
  deliveryStatus: DeliveryStatus;
  drawStatus: DrawStatus;
};

export type PurchaseItemStatus =
  | 'redeemed'
  | 'used'
  | 'expired';

export type DeliveryStatus =
  | null
  | 'packing'
  | 'shipping'
  | 'shipped';

export type DrawStatus =
  | null
  | 'draw_win'
  | 'draw_lose'
  | 'draw_waiting';

export function getPurchaseItemStatus(item: Purchase): PurchaseItemInfo {
  const title = item.Name ?? '';
  const pointPerUnit = item.PointPerUnit ?? 0;
  const image = item.FullImageUrl ?? '';
  const expireDate = new Date((item.VoucherExpireDate ?? 0) * 1000);

  let showCode = true;
  let status: PurchaseItemStatus = 'redeemed';

  let drawStatus: DrawStatus = null;
  if (item.Type === campaignType.draw) {
    showCode = false;
    if (item.HasWinner) {
      drawStatus = item.IsWinner ? 'draw_win' : 'draw_lose';
    } else {
      drawStatus = 'draw_waiting';
    }
  }

  let deliveryStatus: DeliveryStatus = null;
  if (item.Delivered) {
    if (item.IsShipped === false && (item.ParcelNo === null || item.ParcelNo === undefined || item.ParcelNo === '')) {
      deliveryStatus = 'packing';
    } else if (item.IsShipped === false) {
      deliveryStatus = 'shipping';
    } else {
      deliveryStatus = 'shipped';
    }
  }

  if (item.ArrangedDate) {
    return { title, pointPerUnit, expireDate, image, showCode: false, expired: false, status: 'used', deliveryStatus, drawStatus };
  }

  if (item.IsExpired || (item.ExpireIn && item.ExpireIn <= 0)) {
    return { title, pointPerUnit, expireDate, image, showCode: false, expired: true, status: 'expired', deliveryStatus, drawStatus };
  }

  if (item.VoucherExpireDate && item.VoucherExpireDate <= Date.now() / 1000) {
    return { title, pointPerUnit, expireDate, image, showCode: false, expired: true, status: 'expired', deliveryStatus, drawStatus };
  }

  switch (item.Type) {
    case campaignType.free:
    case campaignType.deal:
      status = 'redeemed';
      showCode = true;
      break;
  }

  return {
    title,
    pointPerUnit,
    expireDate,
    image,
    showCode,
    expired: false,
    status,
    deliveryStatus,
    drawStatus,
  };
}
